import axios from 'axios';
import Compress from 'compress.js';
let compressedImage = 'text';
let compressedImage2 = 'text';
let compressedImage3 = 'text';

export const fillRepairDetails = () => {
  document.addEventListener('DOMContentLoaded', function () {
    compressImage1();
    compressImage2();
    compressImage3();

    document.querySelector('input[name="serialNumber"]').value =
      localStorage.getItem('serial-number');

    document
      .querySelector('select[name="repairContent"]')
      .addEventListener('change', function () {
        const repairType = document.querySelector(
          'select[name="repairContent"]'
        ).value;

        if (repairType === 'ハードケース交換のみ') {
          clearRepairPicture();
        } else {
          showRepairPicture();
        }
      });

    submitRepairRequestEvent();
  });
};

const compressImage1 = () => {
  const compress = new Compress();
  compress
    .attach('#photo1', {
      maxHeight: 1024,
      maxWidth: 1024,
    })
    .then((results) => {
      const img1 = results[0];
      const base64str = img1.data;
      const imgExt = img1.ext;
      compressedImage = Compress.convertBase64ToFile(base64str, imgExt);
    });
};

const compressImage2 = () => {
  const compress = new Compress();
  compress
    .attach('#photo2', {
      maxHeight: 1024,
      maxWidth: 1024,
    })
    .then((results) => {
      const img1 = results[0];
      const base64str = img1.data;
      const imgExt = img1.ext;
      compressedImage2 = Compress.convertBase64ToFile(base64str, imgExt);
    });
};

const compressImage3 = () => {
  const compress = new Compress();
  compress
    .attach('#photo3', {
      maxHeight: 1024,
      maxWidth: 1024,
    })
    .then((results) => {
      const img1 = results[0];
      const base64str = img1.data;
      const imgExt = img1.ext;
      compressedImage3 = Compress.convertBase64ToFile(base64str, imgExt);
    });
};

const submitRepairRequestEvent = () => {
  document
    .getElementById('repair-request-form')
    .addEventListener('submit', function (e) {
      e.preventDefault();
      const buttonContainer = document.querySelector(
        '.warranty-submit-container'
      );
      buttonContainer.querySelector('button').disabled = true;
      buttonContainer.querySelector('button').innerHTML =
        '登録 <i class="fa fa-spinner fa-spin"></i>';

      var formData = new FormData();
      formData.append(
        'serialNumber',
        encodeURI(document.querySelector('input[name="serialNumber"]').value)
      );
      formData.append(
        'email',
        document.querySelector('input[name="email"]').value
      );
      formData.append(
        'firstName',
        encodeURI(document.querySelector('input[name="firstName"]').value)
      );
      formData.append(
        'lastName',
        encodeURI(document.querySelector('input[name="lastName"]').value)
      );
      formData.append(
        'customerId',
        document.querySelector('.logged-in').dataset.customerId
      );
      formData.append('file', compressedImage);
      formData.append('file2', compressedImage2);
      formData.append('file3', compressedImage3);
      formData.append(
        'phone',
        encodeURI(document.querySelector('input[name="phoneNumber"]').value)
      );
      formData.append(
        'zip',
        encodeURI(document.querySelector('input[name="zipcode"]').value)
      );
      formData.append(
        'address1',
        encodeURI(document.querySelector('input[name="address1"]').value)
      );
      formData.append(
        'address2',
        encodeURI(document.querySelector('input[name="address2"]').value)
      );
      formData.append(
        'detailedInfo',
        encodeURI(
          document.querySelector('textarea[name="detailedRepair"]').value
        )
      );
      formData.append(
        'repairContent',
        encodeURI(
          document.querySelector('select[name="repairContent"]')
            .selectedOptions[0].value
        )
      );
      formData.append(
        'hmac',
        document.querySelector('.logged-in').dataset.hmac
      );

      axios
        .post(API_URL.repairRequest, formData)
        .then(function (response) {
          if (response.status == 200) {
            document.querySelector('.submit-fail-msg').style.display = 'none';
            localStorage.setItem('submittedRepair', true);
            window.location.href = '/account?view=warranty';
          } else {
            document.querySelector('button[type="submit"]').innerHTML = '登録';
            document.querySelector('.submit-fail-msg').innerHTML =
              response.data;
            document.querySelector('.submit-fail-msg').style.display = 'block';
          }
        })
        .catch(function (error) {
          document.querySelector('button[type="submit"]').innerHTML = '登録';
          document.querySelector('.submit-fail-msg').innerHTML =
            error.response.data;
          document.querySelector('.submit-fail-msg').style.display = 'block';
        });
    });
};

export const grabRepairDetails = () => {
  const repairLinks = Array.from(
    document.querySelectorAll('a[href="/account?view=repair_request"]')
  );
  if (repairLinks) {
    repairLinks.forEach((repairLink) => {
      repairLink.addEventListener('click', (e) => {
        e.preventDefault();
        const details = e.currentTarget.closest('.Table__Item');
        localStorage.setItem(
          'serial-number',
          details.querySelector('#serial-number').textContent
        );
        window.location.href = '/account?view=repair_request';
      });
    });
  }
};

export const displayRepairPopup = () => {
  window.addEventListener('load', function () {
    if (localStorage.getItem('submittedRepair') === 'true') {
      document.getElementById('repair-popup').style.display = 'block';
      setTimeout(function () {
        document.getElementById('repair-popup').style.display = 'none';
      }, 3000);
      localStorage.removeItem('submittedRepair');
      document.addEventListener('mouseup', function (e) {
        var repairPopup = document.getElementById('repair-popup');
        if (!repairPopup.contains(e.target)) {
          repairPopup.style.display = 'none';
        }
      });
    }
  });
};

export const redirectEvent = () => {
  document.addEventListener('DOMContentLoaded', function () {
    var orderHistoryRedirect = document.querySelector(
      '.order-history-redirect'
    );
    if (orderHistoryRedirect) {
      orderHistoryRedirect.addEventListener('click', function (e) {
        e.preventDefault();
        localStorage.setItem('redirected', true);
        window.location.href = '/account?view=warranty';
      });
    }
  });
};

const clearRepairPicture = () => {
  document.querySelector("input[name='photo1']").required = false;
  document.querySelector('#repairPhoto1').style.display = 'none';
  document.querySelector("input[name='photo2']").required = false;
  document.querySelector('#repairPhoto2').style.display = 'none';
  document.querySelector("input[name='photo3']").required = false;
  document.querySelector('#repairPhoto3').style.display = 'none';
};

const showRepairPicture = () => {
  document.querySelector("input[name='photo1']").required = true;
  document.querySelector('#repairPhoto1').style.display = 'block';
  document.querySelector('#repairPhoto2').style.display = 'block';
  document.querySelector('#repairPhoto3').style.display = 'block';
};